var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSmile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.715 7.501-.01.009a.5.5 0 1 0 .705.705l.012-.014.013-.013a1.5 1.5 0 0 1 2.128-.002m-2.848-.685L7.21 8.54M4.715 7.501l.01-.008a2.58 2.58 0 0 1 3.545-.006m-3.555.014 3.555-.014m-.707.7h.002l-.355.353m.353-.354-.353.354m.353-.354a.5.5 0 0 0 .703 0M7.21 8.54a1 1 0 0 0 1.41 0m-.354-.354v.002l.354.352m-.354-.354a.5.5 0 0 0 .004-.699m-.004.7.002-.002.352.355m0 0-.35-1.053m4.404 5.132.006-.005a.501.501 0 1 1 .64.771v.001a5.18 5.18 0 0 1-6.64 0 .501.501 0 0 1 .64-.771l.006.004a4.26 4.26 0 0 0 5.348 0Zm.826-5.835a2.58 2.58 0 0 1 1.77.703.5.5 0 0 1-.004.7.5.5 0 0 1-.703 0 1.5 1.5 0 0 0-2.11-.017.5.5 0 0 1-.707-.697 2.58 2.58 0 0 1 1.754-.689ZM4.722 2.101a9.5 9.5 0 1 1 10.556 15.798A9.5 9.5 0 0 1 4.722 2.1Zm.556 14.966a8.5 8.5 0 1 0 9.444-14.134 8.5 8.5 0 0 0-9.444 14.134Z",
  stroke: "currentColor"
})));

export default SvgSmile;